import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=1501b872&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"
import style0 from "./Image.vue?vue&type=style&index=0&id=1501b872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501b872",
  null
  
)

export default component.exports